import { FaFacebook, FaInstagram, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { Link } from "react-router-dom";
import "./SocialIcon.css"; // We'll create this CSS file

const SocialIcons = () => {
  return (
    <div className="social-icons-container-out">
      <Link
        to="https://youtube.com"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon-out youtube-out"
      >
        <FaYoutube />
      </Link>
      
      <Link
        to="https://facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon-out facebook-out"
      >
        <FaFacebook />
      </Link>

      <Link
        to="https://"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon-out instagram-out"
      >
        <FaInstagram />
      </Link>

      <Link
        to="https://twitter.com"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon-out twitter-out"
      >
        <BsTwitterX />
      </Link>

      <Link
        to="https://wa.me/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon-out whatsapp-out"
      >
        <FaWhatsapp />
      </Link>
    </div>
  );
};

export default SocialIcons;